<template>
  <div class="popUpWrap">
    <section class="popup dark assessment">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <div class="icon caution"></div>
        <div class="textArea flex">
          <h5 v-html="convertToNextLine(t('skillCertify-environment-check-screen-share-permission-required'))"></h5>
        </div>
        <div class="boxArea">
          <ul class="listDot">
            <!--
              macOS 만 시스템 권한 설정 경로를 안내한다. Windows 는 브라우저가 매번 공유 선택기를
              띄우므로 응시자가 바꿀 시스템 설정이 없고, 남는 원인은 차단 프로그램뿐이다.
            -->
            <li v-if="externalDirectorService.isMac"
                v-html="convertToNextLine(t('skillCertify-proctoring-entire-screen-recording-no-access-description-1') + '<br/>' + '<span>' + t('learning-assessment-guide-line-description-for-mac-2') + '</span>' + '<span>' + t('learning-assessment-guide-line-description-for-mac-3') + '</span>')"></li>
            <li>{{ t('skillCertify-proctoring-entire-screen-recording-no-access-description-2') }}</li>
            <!-- 운영팀 확정 링크를 받기 전까지 비활성 — environmentHelpLink.ts 참고. -->
            <li v-if="isHelpDetailEnabled" v-html="helpDetailHtml"></li>
          </ul>
        </div>
        <p class="contactText">{{ t('skillCertify-environment-check-contact-channel-talk') }}</p>
        <div class="btnArea">
          <button @click.stop="onClickClose">{{ t('common-ok') }}</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
/**
 * ASMT-PROCTOR-14 (TSK-11689) — 기본 감독 화면 공유 점검 실패 안내.
 *
 * 취소(사용자가 선택기를 닫음)와는 다른 경로다. 취소는 토스트만 띄우고,
 * 이 팝업은 권한 거부·장치 문제처럼 응시자가 조치해야 해결되는 경우에만 뜬다.
 *
 * BR-1761: 목업(「기본감독_화면공유점검실패시」)대로 정리했다 — 안내는 박스 안 한 덩어리로 모으고
 * 하단 버튼은 [확인] 하나만 둔다. 도움말은 마지막 줄의 인라인 링크가 담당한다.
 */
import { computed } from 'vue';
import { useDialogStore } from "~/store/dialog/dialogStore";
import { convertToNextLine, useI18n } from "#imports";
import { useExternalDirectorService } from "~/composables/service/useExternalDirectorService";
import {
  buildHelpDetailHtml,
  IS_HELP_DETAIL_ENABLED,
} from "~/components/Common/Dialog/dialog/Assessment/environmentHelpLink";

const { t } = useI18n();
const externalDirectorService = useExternalDirectorService();
const dialogStore = useDialogStore();

/**
 * "자세한 해결 방법은 [도움말 보기] 확인" — 문장 안의 링크다.
 *
 * 예전에는 [도움말 보기]가 [확인] 옆의 버튼이었는데, 나란히 놓이면 "둘 중 무엇을 눌러야
 * 팝업이 닫히는지"가 흐려진다. 확인 동작은 하나여야 한다.
 * 링크는 새 탭으로 열려 팝업이 그대로 남는다 — 문서를 읽고 돌아와 바로 재시도할 수 있어야 한다.
 *
 * 확정 링크를 받기 전까지는 그리지 않는다(`IS_HELP_DETAIL_ENABLED`).
 */
const isHelpDetailEnabled = IS_HELP_DETAIL_ENABLED;
const helpDetailHtml = computed(() => buildHelpDetailHtml(t));

const onClickClose = () => {
  dialogStore.close();
  dialogStore.options.close?.event();
};
</script>

<style scoped>
.contactText {
  margin-top: 16px;
}

/*
 * v-html 로 주입된 도움말 링크. scoped 속성이 붙지 않으므로 :deep() 로 내려보낸다.
 * 문장 흐름을 끊지 않도록 인라인으로 두고, 색·밑줄로만 링크임을 알린다.
 */
:deep(.helpLink) {
  color: #81ABFF;
  text-decoration: underline;
}
</style>
